"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.defaultValidationErrorHandler = exports.VideoSource = exports.VatCalculatorActionedField = exports.VatCalculatorActionedAction = exports.TopNavigationSignupActionedAction = exports.SliceUseCaseActionedAction = exports.SignupFormModalOpenedAction = exports.PricingPlanPickerActionedAction = exports.Selected = exports.PricingBillingCycleActionedAction = exports.Value = exports.PerformanceMarketingSignupActionedAction = exports.PageTranslatedAction = exports.PageActionedAction = exports.Kind = exports.Event = exports.InvoiceSubscribeActionedAction = exports.InvoiceGeneratorActionedField = exports.InteractiveDemoActionedAction = exports.HomepageActionedAction = exports.EventCtaActionedAction = exports.Referral = exports.EmailSignupActionedAction = exports.Variant = exports.ErgActionedAction = exports.EpbActionedAction = exports.ElementType = exports.CookiePreferencesActionedAction = exports.CookieBannerActionedAction = exports.ContactUsPageEmailLinkActionedAction = exports.UserStatus = exports.Team = exports.ContactUsPageContactFormActionedAction = exports.BigformActionedAction = void 0;
exports.setTypewriterOptions = setTypewriterOptions;
exports.bigformActioned = bigformActioned;
exports.bigformSubmitted = bigformSubmitted;
exports.bigformViewed = bigformViewed;
exports.contactUsPageContactFormActioned = contactUsPageContactFormActioned;
exports.contactUsPageEmailLinkActioned = contactUsPageEmailLinkActioned;
exports.contactUsPageHeroLinkActioned = contactUsPageHeroLinkActioned;
exports.contactUsPageIntercomLinkActioned = contactUsPageIntercomLinkActioned;
exports.cookieBannerActioned = cookieBannerActioned;
exports.cookiePreferencesActioned = cookiePreferencesActioned;
exports.ctaClicked = ctaClicked;
exports.demoBookingSubmitted = demoBookingSubmitted;
exports.demoBookingViewed = demoBookingViewed;
exports.epbActioned = epbActioned;
exports.ergActioned = ergActioned;
exports.elementClicked = elementClicked;
exports.emailSignupActioned = emailSignupActioned;
exports.eventCtaActioned = eventCtaActioned;
exports.eventsRegisterctaActioned = eventsRegisterctaActioned;
exports.flowCompleted = flowCompleted;
exports.flowStarted = flowStarted;
exports.flowStepCompleted = flowStepCompleted;
exports.flowStepViewed = flowStepViewed;
exports.formSubmitted = formSubmitted;
exports.googleAdsOptimisationSignal = googleAdsOptimisationSignal;
exports.homepageActioned = homepageActioned;
exports.homepageStickyNavActioned = homepageStickyNavActioned;
exports.interactiveDemoActioned = interactiveDemoActioned;
exports.interactiveDemoMobileGateContinueToDemoActioned = interactiveDemoMobileGateContinueToDemoActioned;
exports.interactiveDemoMobileGateReturnHomepageActioned = interactiveDemoMobileGateReturnHomepageActioned;
exports.invoiceGeneratorActioned = invoiceGeneratorActioned;
exports.invoiceSubscribeActioned = invoiceSubscribeActioned;
exports.navatticEvent = navatticEvent;
exports.newsletterSignupFormSubmitted = newsletterSignupFormSubmitted;
exports.notificationBannerActioned = notificationBannerActioned;
exports.pageActioned = pageActioned;
exports.pageTranslated = pageTranslated;
exports.pageViewed = pageViewed;
exports.partnerCtaActioned = partnerCtaActioned;
exports.performanceMarketingSignupActioned = performanceMarketingSignupActioned;
exports.planSelected = planSelected;
exports.pricingBillingCycleActioned = pricingBillingCycleActioned;
exports.pricingPlanPickerActioned = pricingPlanPickerActioned;
exports.pricingSliderActioned = pricingSliderActioned;
exports.pricingTooltipActioned = pricingTooltipActioned;
exports.roicActioned = roicActioned;
exports.resourceRequested = resourceRequested;
exports.signupFormModalOpened = signupFormModalOpened;
exports.signupFormSubmitted = signupFormSubmitted;
exports.signupFunnelSignalEvent = signupFunnelSignalEvent;
exports.sliceUseCaseActioned = sliceUseCaseActioned;
exports.sliderCardsButtonActioned = sliderCardsButtonActioned;
exports.topNavigationSignupActioned = topNavigationSignupActioned;
exports.treasuryFormSubmitted = treasuryFormSubmitted;
exports.vatCalculatorActioned = vatCalculatorActioned;
exports.videoPlayed = videoPlayed;
exports.webinarFormSubmitted = webinarFormSubmitted;
exports.webinarVideoViewed = webinarVideoViewed;
exports.webinarsWatchNowctaActioned = webinarsWatchNowctaActioned;
var BigformActionedAction;
(function (BigformActionedAction) {
    BigformActionedAction["Completed"] = "completed";
    BigformActionedAction["Interacted"] = "interacted";
    BigformActionedAction["Started"] = "started";
})(BigformActionedAction || (exports.BigformActionedAction = BigformActionedAction = {}));
var ContactUsPageContactFormActionedAction;
(function (ContactUsPageContactFormActionedAction) {
    ContactUsPageContactFormActionedAction["Submitted"] = "submitted";
})(ContactUsPageContactFormActionedAction || (exports.ContactUsPageContactFormActionedAction = ContactUsPageContactFormActionedAction = {}));
var Team;
(function (Team) {
    Team["Partnerships"] = "partnerships";
    Team["Support"] = "support";
})(Team || (exports.Team = Team = {}));
var UserStatus;
(function (UserStatus) {
    UserStatus["LoggedIn"] = "logged in";
    UserStatus["NotLoggedIn"] = "not logged in";
})(UserStatus || (exports.UserStatus = UserStatus = {}));
var ContactUsPageEmailLinkActionedAction;
(function (ContactUsPageEmailLinkActionedAction) {
    ContactUsPageEmailLinkActionedAction["Completed"] = "completed";
})(ContactUsPageEmailLinkActionedAction || (exports.ContactUsPageEmailLinkActionedAction = ContactUsPageEmailLinkActionedAction = {}));
var CookieBannerActionedAction;
(function (CookieBannerActionedAction) {
    CookieBannerActionedAction["Dismissed"] = "dismissed";
    CookieBannerActionedAction["Shown"] = "shown";
})(CookieBannerActionedAction || (exports.CookieBannerActionedAction = CookieBannerActionedAction = {}));
var CookiePreferencesActionedAction;
(function (CookiePreferencesActionedAction) {
    CookiePreferencesActionedAction["Closed"] = "closed";
    CookiePreferencesActionedAction["Opened"] = "opened";
    CookiePreferencesActionedAction["Saved"] = "saved";
})(CookiePreferencesActionedAction || (exports.CookiePreferencesActionedAction = CookiePreferencesActionedAction = {}));
/**
 * The type of element that was clicked.
 */
var ElementType;
(function (ElementType) {
    ElementType["Button"] = "button";
    ElementType["Checkbox"] = "checkbox";
    ElementType["Icon"] = "icon";
    ElementType["Link"] = "link";
    ElementType["Option"] = "option";
    ElementType["Radio"] = "radio";
    ElementType["Switch"] = "switch";
    ElementType["Tab"] = "tab";
})(ElementType || (exports.ElementType = ElementType = {}));
var EpbActionedAction;
(function (EpbActionedAction) {
    EpbActionedAction["PdfDownloaded"] = "pdf_downloaded";
    EpbActionedAction["PdfGenerated"] = "pdf_generated";
})(EpbActionedAction || (exports.EpbActionedAction = EpbActionedAction = {}));
var ErgActionedAction;
(function (ErgActionedAction) {
    ErgActionedAction["AlmostThereStepReached"] = "almost_there_step_reached";
    ErgActionedAction["ExpenseAdded"] = "expense_added";
    ErgActionedAction["ExpenseDeleted"] = "expense_deleted";
    ErgActionedAction["FirstInteraction"] = "first_interaction";
    ErgActionedAction["PdfDownloaded"] = "pdf_downloaded";
    ErgActionedAction["PdfGenerated"] = "pdf_generated";
    ErgActionedAction["PdfShared"] = "pdf_shared";
    ErgActionedAction["PreviewOpened"] = "preview_opened";
    ErgActionedAction["SuccessStepReached"] = "success_step_reached";
})(ErgActionedAction || (exports.ErgActionedAction = ErgActionedAction = {}));
var Variant;
(function (Variant) {
    Variant["External"] = "external";
    Variant["Internal"] = "internal";
})(Variant || (exports.Variant = Variant = {}));
var EmailSignupActionedAction;
(function (EmailSignupActionedAction) {
    EmailSignupActionedAction["Blocked"] = "blocked";
    EmailSignupActionedAction["Submitted"] = "submitted";
})(EmailSignupActionedAction || (exports.EmailSignupActionedAction = EmailSignupActionedAction = {}));
var Referral;
(function (Referral) {
    Referral["No"] = "no";
    Referral["Yes"] = "yes";
})(Referral || (exports.Referral = Referral = {}));
var EventCtaActionedAction;
(function (EventCtaActionedAction) {
    EventCtaActionedAction["Clicked"] = "clicked";
})(EventCtaActionedAction || (exports.EventCtaActionedAction = EventCtaActionedAction = {}));
var HomepageActionedAction;
(function (HomepageActionedAction) {
    HomepageActionedAction["HeroVideoClicked"] = "hero_video_clicked";
    HomepageActionedAction["SectionViewed"] = "section_viewed";
})(HomepageActionedAction || (exports.HomepageActionedAction = HomepageActionedAction = {}));
var InteractiveDemoActionedAction;
(function (InteractiveDemoActionedAction) {
    InteractiveDemoActionedAction["Viewed"] = "viewed";
})(InteractiveDemoActionedAction || (exports.InteractiveDemoActionedAction = InteractiveDemoActionedAction = {}));
var InvoiceGeneratorActionedField;
(function (InvoiceGeneratorActionedField) {
    InvoiceGeneratorActionedField["EmailSubmitted"] = "email submitted";
    InvoiceGeneratorActionedField["GetInvoice"] = "get invoice";
    InvoiceGeneratorActionedField["InvoiceDetails"] = "invoice details";
    InvoiceGeneratorActionedField["InvoiceItems"] = "invoice items";
    InvoiceGeneratorActionedField["NewInvoice"] = "new invoice";
    InvoiceGeneratorActionedField["Notes"] = "notes";
    InvoiceGeneratorActionedField["PdfDownloaded"] = "pdf downloaded";
    InvoiceGeneratorActionedField["Preview"] = "preview";
    InvoiceGeneratorActionedField["RecipientDetails"] = "recipient details";
    InvoiceGeneratorActionedField["YourCompanyDetails"] = "your company details";
})(InvoiceGeneratorActionedField || (exports.InvoiceGeneratorActionedField = InvoiceGeneratorActionedField = {}));
var InvoiceSubscribeActionedAction;
(function (InvoiceSubscribeActionedAction) {
    InvoiceSubscribeActionedAction["Subscribed"] = "subscribed";
})(InvoiceSubscribeActionedAction || (exports.InvoiceSubscribeActionedAction = InvoiceSubscribeActionedAction = {}));
var Event;
(function (Event) {
    Event["CloseChecklist"] = "CLOSE_CHECKLIST";
    Event["CompleteFlow"] = "COMPLETE_FLOW";
    Event["Converted"] = "CONVERTED";
    Event["IdentifyUser"] = "IDENTIFY_USER";
    Event["Navigate"] = "NAVIGATE";
    Event["OpenChecklist"] = "OPEN_CHECKLIST";
    Event["StartChecklist"] = "START_CHECKLIST";
    Event["StartFlow"] = "START_FLOW";
    Event["ViewStep"] = "VIEW_STEP";
})(Event || (exports.Event = Event = {}));
var Kind;
(function (Kind) {
    Kind["NavatticEvent"] = "navattic:event";
    Kind["NavatticStylesheetsLoaded"] = "navattic:stylesheetsLoaded";
})(Kind || (exports.Kind = Kind = {}));
var PageActionedAction;
(function (PageActionedAction) {
    PageActionedAction["SectionViewed"] = "section_viewed";
})(PageActionedAction || (exports.PageActionedAction = PageActionedAction = {}));
var PageTranslatedAction;
(function (PageTranslatedAction) {
    PageTranslatedAction["PageTranslated"] = "page_translated";
})(PageTranslatedAction || (exports.PageTranslatedAction = PageTranslatedAction = {}));
var PerformanceMarketingSignupActionedAction;
(function (PerformanceMarketingSignupActionedAction) {
    PerformanceMarketingSignupActionedAction["Started"] = "started";
})(PerformanceMarketingSignupActionedAction || (exports.PerformanceMarketingSignupActionedAction = PerformanceMarketingSignupActionedAction = {}));
/**
 * The name of the selected plan
 */
var Value;
(function (Value) {
    Value["Build"] = "build";
    Value["Lead"] = "lead";
    Value["Optimise"] = "optimise";
    Value["Scale"] = "scale";
    Value["Start"] = "start";
})(Value || (exports.Value = Value = {}));
var PricingBillingCycleActionedAction;
(function (PricingBillingCycleActionedAction) {
    PricingBillingCycleActionedAction["Changed"] = "changed";
})(PricingBillingCycleActionedAction || (exports.PricingBillingCycleActionedAction = PricingBillingCycleActionedAction = {}));
var Selected;
(function (Selected) {
    Selected["Monthly"] = "monthly";
    Selected["Yearly"] = "yearly";
})(Selected || (exports.Selected = Selected = {}));
var PricingPlanPickerActionedAction;
(function (PricingPlanPickerActionedAction) {
    PricingPlanPickerActionedAction["ViewQuestion"] = "view_question";
})(PricingPlanPickerActionedAction || (exports.PricingPlanPickerActionedAction = PricingPlanPickerActionedAction = {}));
var SignupFormModalOpenedAction;
(function (SignupFormModalOpenedAction) {
    SignupFormModalOpenedAction["Opened"] = "opened";
})(SignupFormModalOpenedAction || (exports.SignupFormModalOpenedAction = SignupFormModalOpenedAction = {}));
var SliceUseCaseActionedAction;
(function (SliceUseCaseActionedAction) {
    SliceUseCaseActionedAction["Completed"] = "completed";
    SliceUseCaseActionedAction["CompletedWithoutSelection"] = "completed without selection";
    SliceUseCaseActionedAction["Started"] = "started";
})(SliceUseCaseActionedAction || (exports.SliceUseCaseActionedAction = SliceUseCaseActionedAction = {}));
var TopNavigationSignupActionedAction;
(function (TopNavigationSignupActionedAction) {
    TopNavigationSignupActionedAction["Partners"] = "partners";
    TopNavigationSignupActionedAction["Started"] = "started";
})(TopNavigationSignupActionedAction || (exports.TopNavigationSignupActionedAction = TopNavigationSignupActionedAction = {}));
var VatCalculatorActionedAction;
(function (VatCalculatorActionedAction) {
    VatCalculatorActionedAction["Actioned"] = "actioned";
    VatCalculatorActionedAction["Completed"] = "completed";
    VatCalculatorActionedAction["Interacted"] = "interacted";
})(VatCalculatorActionedAction || (exports.VatCalculatorActionedAction = VatCalculatorActionedAction = {}));
var VatCalculatorActionedField;
(function (VatCalculatorActionedField) {
    VatCalculatorActionedField["Amount"] = "amount";
    VatCalculatorActionedField["Calculate"] = "calculate";
    VatCalculatorActionedField["Delete"] = "delete";
    VatCalculatorActionedField["VatAmount"] = "VAT % amount";
})(VatCalculatorActionedField || (exports.VatCalculatorActionedField = VatCalculatorActionedField = {}));
/**
 * Source of the video asset used for playback.
 */
var VideoSource;
(function (VideoSource) {
    VideoSource["Native"] = "native";
    VideoSource["Wistia"] = "wistia";
})(VideoSource || (exports.VideoSource = VideoSource = {}));
/**
 * The default handler that is fired if none is supplied with setTypewriterOptions.
 * This handler will log a warning message to the console.
 */
const defaultValidationErrorHandler = (message, violations) => {
    const msg = JSON.stringify({
        type: 'Typewriter JSON Schema Validation Error',
        description: `You made an analytics call (${message.event}) using Typewriter that doesn't match the ` +
            'Tracking Plan spec.',
        errors: violations,
    }, undefined, 2);
    console.warn(msg);
};
exports.defaultValidationErrorHandler = defaultValidationErrorHandler;
let analytics = () => {
    return window.analytics;
};
/**
 * Updates the run-time configuration of this Typewriter client.
 *
 * @param {TypewriterOptions} options - the options to upsert
 *
 * @typedef {Object} TypewriterOptions
 * @property {AnyAnalytics} [analytics] - Underlying analytics instance where analytics
 * 		calls are forwarded on to. Defaults to window.analytics.
 * @property {Function} [onViolation] - Handler fired when if an event does not match its spec. This handler does not fire in
 * 		production mode, because it requires inlining the full JSON Schema spec for each event in your Tracking Plan. By default,
 * 		it will throw errors if NODE_ENV="test" so that tests will fail if a message does not match the spec. Otherwise, errors
 * 		will be logged to stderr.
 */
function setTypewriterOptions(options) {
    analytics = options.analytics ? () => options.analytics || window.analytics : analytics;
}
/**
 * Helper to attach metadata on Typewriter to outbound requests.
 * This is used for attribution and debugging by the Segment team.
 */
function withTypewriterContext(message = {}) {
    return {
        ...message,
        context: {
            ...(message.context || {}),
            typewriter: {
                language: 'typescript',
                version: '9.2.0',
            },
        },
    };
}
/**
 * Fires a 'BigformActioned' track call.
 *
 * @param BigformActioned props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
function bigformActioned(props, options, callback) {
    const a = analytics();
    if (a) {
        a.track('Bigform Actioned', props || {}, {
            ...options,
            context: {
                ...(options?.context || {}),
                typewriter: {
                    language: 'typescript',
                    version: '',
                },
            },
        }, callback);
    }
}
/**
 * Fires a 'BigformSubmitted' track call.
 *
 * @param BigformSubmitted props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
function bigformSubmitted(props, options, callback) {
    const a = analytics();
    if (a) {
        a.track('Bigform Submitted', props || {}, {
            ...options,
            context: {
                ...(options?.context || {}),
                typewriter: {
                    language: 'typescript',
                    version: '',
                },
            },
        }, callback);
    }
}
/**
 * Fires a 'BigformViewed' track call.
 *
 * @param BigformViewed props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
function bigformViewed(props, options, callback) {
    const a = analytics();
    if (a) {
        a.track('Bigform Viewed', props || {}, {
            ...options,
            context: {
                ...(options?.context || {}),
                typewriter: {
                    language: 'typescript',
                    version: '',
                },
            },
        }, callback);
    }
}
/**
 * Fires a 'ContactUsPageContactFormActioned' track call.
 *
 * @param ContactUsPageContactFormActioned props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
function contactUsPageContactFormActioned(props, options, callback) {
    const a = analytics();
    if (a) {
        a.track('Contact Us Page Contact Form Actioned', props || {}, {
            ...options,
            context: {
                ...(options?.context || {}),
                typewriter: {
                    language: 'typescript',
                    version: '',
                },
            },
        }, callback);
    }
}
/**
 * Fires a 'ContactUsPageEmailLinkActioned' track call.
 *
 * @param ContactUsPageEmailLinkActioned props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
function contactUsPageEmailLinkActioned(props, options, callback) {
    const a = analytics();
    if (a) {
        a.track('Contact Us Page Email Link Actioned', props || {}, {
            ...options,
            context: {
                ...(options?.context || {}),
                typewriter: {
                    language: 'typescript',
                    version: '',
                },
            },
        }, callback);
    }
}
/**
 * Fires a 'ContactUsPageHeroLinkActioned' track call.
 *
 * @param ContactUsPageHeroLinkActioned props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
function contactUsPageHeroLinkActioned(props, options, callback) {
    const a = analytics();
    if (a) {
        a.track('Contact Us Page Hero Link Actioned', props || {}, {
            ...options,
            context: {
                ...(options?.context || {}),
                typewriter: {
                    language: 'typescript',
                    version: '',
                },
            },
        }, callback);
    }
}
/**
 * Fires a 'ContactUsPageIntercomLinkActioned' track call.
 *
 * @param ContactUsPageIntercomLinkActioned props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
function contactUsPageIntercomLinkActioned(props, options, callback) {
    const a = analytics();
    if (a) {
        a.track('Contact Us Page Intercom Link Actioned', props || {}, {
            ...options,
            context: {
                ...(options?.context || {}),
                typewriter: {
                    language: 'typescript',
                    version: '',
                },
            },
        }, callback);
    }
}
/**
 * Fires a 'CookieBannerActioned' track call.
 *
 * @param CookieBannerActioned props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
function cookieBannerActioned(props, options, callback) {
    const a = analytics();
    if (a) {
        a.track('Cookie Banner Actioned', props || {}, {
            ...options,
            context: {
                ...(options?.context || {}),
                typewriter: {
                    language: 'typescript',
                    version: '',
                },
            },
        }, callback);
    }
}
/**
 * Fires a 'CookiePreferencesActioned' track call.
 *
 * @param CookiePreferencesActioned props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
function cookiePreferencesActioned(props, options, callback) {
    const a = analytics();
    if (a) {
        a.track('Cookie Preferences Actioned', props || {}, {
            ...options,
            context: {
                ...(options?.context || {}),
                typewriter: {
                    language: 'typescript',
                    version: '',
                },
            },
        }, callback);
    }
}
/**
 * Fires a 'CtaClicked' track call.
 *
 * @param CtaClicked props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
function ctaClicked(props, options, callback) {
    const a = analytics();
    if (a) {
        a.track('Cta Clicked', props || {}, {
            ...options,
            context: {
                ...(options?.context || {}),
                typewriter: {
                    language: 'typescript',
                    version: '',
                },
            },
        }, callback);
    }
}
/**
 * Fires a 'DemoBookingSubmitted' track call.
 *
 * @param DemoBookingSubmitted props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
function demoBookingSubmitted(props, options, callback) {
    const a = analytics();
    if (a) {
        a.track('Demo Booking Submitted', props || {}, {
            ...options,
            context: {
                ...(options?.context || {}),
                typewriter: {
                    language: 'typescript',
                    version: '',
                },
            },
        }, callback);
    }
}
/**
 * Fires a 'DemoBookingViewed' track call.
 *
 * @param DemoBookingViewed props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
function demoBookingViewed(props, options, callback) {
    const a = analytics();
    if (a) {
        a.track('Demo Booking Viewed', props || {}, {
            ...options,
            context: {
                ...(options?.context || {}),
                typewriter: {
                    language: 'typescript',
                    version: '',
                },
            },
        }, callback);
    }
}
/**
 * Fires a 'EpbActioned' track call.
 *
 * @param EpbActioned props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
function epbActioned(props, options, callback) {
    const a = analytics();
    if (a) {
        a.track('EPB Actioned', props || {}, {
            ...options,
            context: {
                ...(options?.context || {}),
                typewriter: {
                    language: 'typescript',
                    version: '',
                },
            },
        }, callback);
    }
}
/**
 * Fires a 'ErgActioned' track call.
 *
 * @param ErgActioned props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
function ergActioned(props, options, callback) {
    const a = analytics();
    if (a) {
        a.track('ERG Actioned', props || {}, {
            ...options,
            context: {
                ...(options?.context || {}),
                typewriter: {
                    language: 'typescript',
                    version: '',
                },
            },
        }, callback);
    }
}
/**
 * Fires a 'ElementClicked' track call.
 *
 * @param ElementClicked props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
function elementClicked(props, options, callback) {
    const a = analytics();
    if (a) {
        a.track('Element Clicked', props || {}, {
            ...options,
            context: {
                ...(options?.context || {}),
                typewriter: {
                    language: 'typescript',
                    version: '',
                },
            },
        }, callback);
    }
}
/**
 * Fires a 'EmailSignupActioned' track call.
 *
 * @param EmailSignupActioned props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
function emailSignupActioned(props, options, callback) {
    const a = analytics();
    if (a) {
        a.track('Email Signup Actioned', props || {}, {
            ...options,
            context: {
                ...(options?.context || {}),
                typewriter: {
                    language: 'typescript',
                    version: '',
                },
            },
        }, callback);
    }
}
/**
 * Fires a 'EventCtaActioned' track call.
 *
 * @param EventCtaActioned props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
function eventCtaActioned(props, options, callback) {
    const a = analytics();
    if (a) {
        a.track('Event Cta Actioned', props || {}, {
            ...options,
            context: {
                ...(options?.context || {}),
                typewriter: {
                    language: 'typescript',
                    version: '',
                },
            },
        }, callback);
    }
}
/**
 * Fires a 'EventsRegisterctaActioned' track call.
 *
 * @param EventsRegisterctaActioned props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
function eventsRegisterctaActioned(props, options, callback) {
    const a = analytics();
    if (a) {
        a.track('Events Register CTA Actioned', props || {}, {
            ...options,
            context: {
                ...(options?.context || {}),
                typewriter: {
                    language: 'typescript',
                    version: '',
                },
            },
        }, callback);
    }
}
/**
 * Fires a 'FlowCompleted' track call.
 *
 * @param FlowCompleted props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
function flowCompleted(props, options, callback) {
    const a = analytics();
    if (a) {
        a.track('Flow Completed', props || {}, {
            ...options,
            context: {
                ...(options?.context || {}),
                typewriter: {
                    language: 'typescript',
                    version: '',
                },
            },
        }, callback);
    }
}
/**
 * Fires a 'FlowStarted' track call.
 *
 * @param FlowStarted props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
function flowStarted(props, options, callback) {
    const a = analytics();
    if (a) {
        a.track('Flow Started', props || {}, {
            ...options,
            context: {
                ...(options?.context || {}),
                typewriter: {
                    language: 'typescript',
                    version: '',
                },
            },
        }, callback);
    }
}
/**
 * Fires a 'FlowStepCompleted' track call.
 *
 * @param FlowStepCompleted props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
function flowStepCompleted(props, options, callback) {
    const a = analytics();
    if (a) {
        a.track('Flow Step Completed', props || {}, {
            ...options,
            context: {
                ...(options?.context || {}),
                typewriter: {
                    language: 'typescript',
                    version: '',
                },
            },
        }, callback);
    }
}
/**
 * Fires a 'FlowStepViewed' track call.
 *
 * @param FlowStepViewed props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
function flowStepViewed(props, options, callback) {
    const a = analytics();
    if (a) {
        a.track('Flow Step Viewed', props || {}, {
            ...options,
            context: {
                ...(options?.context || {}),
                typewriter: {
                    language: 'typescript',
                    version: '',
                },
            },
        }, callback);
    }
}
/**
 * Fires a 'FormSubmitted' track call.
 *
 * @param FormSubmitted props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
function formSubmitted(props, options, callback) {
    const a = analytics();
    if (a) {
        a.track('Form Submitted', props || {}, {
            ...options,
            context: {
                ...(options?.context || {}),
                typewriter: {
                    language: 'typescript',
                    version: '',
                },
            },
        }, callback);
    }
}
/**
 * Fires a 'GoogleAdsOptimisationSignal' track call.
 *
 * @param GoogleAdsOptimisationSignal props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
function googleAdsOptimisationSignal(props, options, callback) {
    const a = analytics();
    if (a) {
        a.track('Google Ads Optimisation Signal', props || {}, {
            ...options,
            context: {
                ...(options?.context || {}),
                typewriter: {
                    language: 'typescript',
                    version: '',
                },
            },
        }, callback);
    }
}
/**
 * Fires a 'HomepageActioned' track call.
 *
 * @param HomepageActioned props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
function homepageActioned(props, options, callback) {
    const a = analytics();
    if (a) {
        a.track('Homepage Actioned', props || {}, {
            ...options,
            context: {
                ...(options?.context || {}),
                typewriter: {
                    language: 'typescript',
                    version: '',
                },
            },
        }, callback);
    }
}
/**
 * Fires a 'HomepageStickyNavActioned' track call.
 *
 * @param HomepageStickyNavActioned props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
function homepageStickyNavActioned(props, options, callback) {
    const a = analytics();
    if (a) {
        a.track('Homepage Sticky Nav Actioned', props || {}, {
            ...options,
            context: {
                ...(options?.context || {}),
                typewriter: {
                    language: 'typescript',
                    version: '',
                },
            },
        }, callback);
    }
}
/**
 * Fires a 'InteractiveDemoActioned' track call.
 *
 * @param InteractiveDemoActioned props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
function interactiveDemoActioned(props, options, callback) {
    const a = analytics();
    if (a) {
        a.track('Interactive Demo Actioned', props || {}, {
            ...options,
            context: {
                ...(options?.context || {}),
                typewriter: {
                    language: 'typescript',
                    version: '',
                },
            },
        }, callback);
    }
}
/**
 * Fires a 'InteractiveDemoMobileGateContinueToDemoActioned' track call.
 *
 * @param InteractiveDemoMobileGateContinueToDemoActioned props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
function interactiveDemoMobileGateContinueToDemoActioned(props, options, callback) {
    const a = analytics();
    if (a) {
        a.track('Interactive Demo Mobile Gate Continue to Demo Actioned', props || {}, {
            ...options,
            context: {
                ...(options?.context || {}),
                typewriter: {
                    language: 'typescript',
                    version: '',
                },
            },
        }, callback);
    }
}
/**
 * Fires a 'InteractiveDemoMobileGateReturnHomepageActioned' track call.
 *
 * @param InteractiveDemoMobileGateReturnHomepageActioned props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
function interactiveDemoMobileGateReturnHomepageActioned(props, options, callback) {
    const a = analytics();
    if (a) {
        a.track('Interactive Demo Mobile Gate Return Homepage Actioned', props || {}, {
            ...options,
            context: {
                ...(options?.context || {}),
                typewriter: {
                    language: 'typescript',
                    version: '',
                },
            },
        }, callback);
    }
}
/**
 * Fires a 'InvoiceGeneratorActioned' track call.
 *
 * @param InvoiceGeneratorActioned props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
function invoiceGeneratorActioned(props, options, callback) {
    const a = analytics();
    if (a) {
        a.track('Invoice Generator Actioned', props || {}, {
            ...options,
            context: {
                ...(options?.context || {}),
                typewriter: {
                    language: 'typescript',
                    version: '',
                },
            },
        }, callback);
    }
}
/**
 * Fires a 'InvoiceSubscribeActioned' track call.
 *
 * @param InvoiceSubscribeActioned props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
function invoiceSubscribeActioned(props, options, callback) {
    const a = analytics();
    if (a) {
        a.track('Invoice Subscribe Actioned', props || {}, {
            ...options,
            context: {
                ...(options?.context || {}),
                typewriter: {
                    language: 'typescript',
                    version: '',
                },
            },
        }, callback);
    }
}
/**
 * Fires a 'NavatticEvent' track call.
 *
 * @param NavatticEvent props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
function navatticEvent(props, options, callback) {
    const a = analytics();
    if (a) {
        a.track('Navattic Event', props || {}, {
            ...options,
            context: {
                ...(options?.context || {}),
                typewriter: {
                    language: 'typescript',
                    version: '',
                },
            },
        }, callback);
    }
}
/**
 * Fires a 'NewsletterSignupFormSubmitted' track call.
 *
 * @param NewsletterSignupFormSubmitted props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
function newsletterSignupFormSubmitted(props, options, callback) {
    const a = analytics();
    if (a) {
        a.track('Newsletter signup form submitted', props || {}, {
            ...options,
            context: {
                ...(options?.context || {}),
                typewriter: {
                    language: 'typescript',
                    version: '',
                },
            },
        }, callback);
    }
}
/**
 * Fires a 'NotificationBannerActioned' track call.
 *
 * @param NotificationBannerActioned props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
function notificationBannerActioned(props, options, callback) {
    const a = analytics();
    if (a) {
        a.track('Notification Banner Actioned', props || {}, {
            ...options,
            context: {
                ...(options?.context || {}),
                typewriter: {
                    language: 'typescript',
                    version: '',
                },
            },
        }, callback);
    }
}
/**
 * Fires a 'PageActioned' track call.
 *
 * @param PageActioned props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
function pageActioned(props, options, callback) {
    const a = analytics();
    if (a) {
        a.track('Page Actioned', props || {}, {
            ...options,
            context: {
                ...(options?.context || {}),
                typewriter: {
                    language: 'typescript',
                    version: '',
                },
            },
        }, callback);
    }
}
/**
 * Fires a 'PageTranslated' track call.
 *
 * @param PageTranslated props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
function pageTranslated(props, options, callback) {
    const a = analytics();
    if (a) {
        a.track('Page Translated', props || {}, {
            ...options,
            context: {
                ...(options?.context || {}),
                typewriter: {
                    language: 'typescript',
                    version: '',
                },
            },
        }, callback);
    }
}
/**
 * Fires a 'PageViewed' track call.
 *
 * @param PageViewed props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
function pageViewed(props, options, callback) {
    const a = analytics();
    if (a) {
        a.track('Page Viewed', props || {}, {
            ...options,
            context: {
                ...(options?.context || {}),
                typewriter: {
                    language: 'typescript',
                    version: '',
                },
            },
        }, callback);
    }
}
/**
 * Fires a 'PartnerCtaActioned' track call.
 *
 * @param PartnerCtaActioned props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
function partnerCtaActioned(props, options, callback) {
    const a = analytics();
    if (a) {
        a.track('Partner Cta Actioned', props || {}, {
            ...options,
            context: {
                ...(options?.context || {}),
                typewriter: {
                    language: 'typescript',
                    version: '',
                },
            },
        }, callback);
    }
}
/**
 * Fires a 'PerformanceMarketingSignupActioned' track call.
 *
 * @param PerformanceMarketingSignupActioned props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
function performanceMarketingSignupActioned(props, options, callback) {
    const a = analytics();
    if (a) {
        a.track('Performance Marketing - Signup Actioned', props || {}, {
            ...options,
            context: {
                ...(options?.context || {}),
                typewriter: {
                    language: 'typescript',
                    version: '',
                },
            },
        }, callback);
    }
}
/**
 * Fires a 'PlanSelected' track call.
 *
 * @param PlanSelected props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
function planSelected(props, options, callback) {
    const a = analytics();
    if (a) {
        a.track('Plan selected', props || {}, {
            ...options,
            context: {
                ...(options?.context || {}),
                typewriter: {
                    language: 'typescript',
                    version: '',
                },
            },
        }, callback);
    }
}
/**
 * Fires a 'PricingBillingCycleActioned' track call.
 *
 * @param PricingBillingCycleActioned props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
function pricingBillingCycleActioned(props, options, callback) {
    const a = analytics();
    if (a) {
        a.track('Pricing Billing Cycle Actioned', props || {}, {
            ...options,
            context: {
                ...(options?.context || {}),
                typewriter: {
                    language: 'typescript',
                    version: '',
                },
            },
        }, callback);
    }
}
/**
 * Fires a 'PricingPlanPickerActioned' track call.
 *
 * @param PricingPlanPickerActioned props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
function pricingPlanPickerActioned(props, options, callback) {
    const a = analytics();
    if (a) {
        a.track('Pricing Plan Picker Actioned', props || {}, {
            ...options,
            context: {
                ...(options?.context || {}),
                typewriter: {
                    language: 'typescript',
                    version: '',
                },
            },
        }, callback);
    }
}
/**
 * Fires a 'PricingSliderActioned' track call.
 *
 * @param PricingSliderActioned props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
function pricingSliderActioned(props, options, callback) {
    const a = analytics();
    if (a) {
        a.track('Pricing Slider Actioned', props || {}, {
            ...options,
            context: {
                ...(options?.context || {}),
                typewriter: {
                    language: 'typescript',
                    version: '',
                },
            },
        }, callback);
    }
}
/**
 * Fires a 'PricingTooltipActioned' track call.
 *
 * @param PricingTooltipActioned props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
function pricingTooltipActioned(props, options, callback) {
    const a = analytics();
    if (a) {
        a.track('Pricing Tooltip Actioned', props || {}, {
            ...options,
            context: {
                ...(options?.context || {}),
                typewriter: {
                    language: 'typescript',
                    version: '',
                },
            },
        }, callback);
    }
}
/**
 * Fires a 'RoicActioned' track call.
 *
 * @param RoicActioned props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
function roicActioned(props, options, callback) {
    const a = analytics();
    if (a) {
        a.track('ROIC Actioned', props || {}, {
            ...options,
            context: {
                ...(options?.context || {}),
                typewriter: {
                    language: 'typescript',
                    version: '',
                },
            },
        }, callback);
    }
}
/**
 * Fires a 'ResourceRequested' track call.
 *
 * @param ResourceRequested props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
function resourceRequested(props, options, callback) {
    const a = analytics();
    if (a) {
        a.track('Resource Requested', props || {}, {
            ...options,
            context: {
                ...(options?.context || {}),
                typewriter: {
                    language: 'typescript',
                    version: '',
                },
            },
        }, callback);
    }
}
/**
 * Fires a 'SignupFormModalOpened' track call.
 *
 * @param SignupFormModalOpened props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
function signupFormModalOpened(props, options, callback) {
    const a = analytics();
    if (a) {
        a.track('Signup Form Modal Opened', props || {}, {
            ...options,
            context: {
                ...(options?.context || {}),
                typewriter: {
                    language: 'typescript',
                    version: '',
                },
            },
        }, callback);
    }
}
/**
 * Fires a 'SignupFormSubmitted' track call.
 *
 * @param SignupFormSubmitted props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
function signupFormSubmitted(props, options, callback) {
    const a = analytics();
    if (a) {
        a.track('Signup Form Submitted', props || {}, {
            ...options,
            context: {
                ...(options?.context || {}),
                typewriter: {
                    language: 'typescript',
                    version: '',
                },
            },
        }, callback);
    }
}
/**
 * Fires a 'SignupFunnelSignalEvent' track call.
 *
 * @param SignupFunnelSignalEvent props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
function signupFunnelSignalEvent(props, options, callback) {
    const a = analytics();
    if (a) {
        a.track('Signup Funnel Signal Event', props || {}, {
            ...options,
            context: {
                ...(options?.context || {}),
                typewriter: {
                    language: 'typescript',
                    version: '',
                },
            },
        }, callback);
    }
}
/**
 * Fires a 'SliceUseCaseActioned' track call.
 *
 * @param SliceUseCaseActioned props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
function sliceUseCaseActioned(props, options, callback) {
    const a = analytics();
    if (a) {
        a.track('Slice Use Case Actioned', props || {}, {
            ...options,
            context: {
                ...(options?.context || {}),
                typewriter: {
                    language: 'typescript',
                    version: '',
                },
            },
        }, callback);
    }
}
/**
 * Fires a 'SliderCardsButtonActioned' track call.
 *
 * @param SliderCardsButtonActioned props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
function sliderCardsButtonActioned(props, options, callback) {
    const a = analytics();
    if (a) {
        a.track('SliderCards Button Actioned', props || {}, {
            ...options,
            context: {
                ...(options?.context || {}),
                typewriter: {
                    language: 'typescript',
                    version: '',
                },
            },
        }, callback);
    }
}
/**
 * Fires a 'TopNavigationSignupActioned' track call.
 *
 * @param TopNavigationSignupActioned props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
function topNavigationSignupActioned(props, options, callback) {
    const a = analytics();
    if (a) {
        a.track('Top Navigation Signup Actioned', props || {}, {
            ...options,
            context: {
                ...(options?.context || {}),
                typewriter: {
                    language: 'typescript',
                    version: '',
                },
            },
        }, callback);
    }
}
/**
 * Fires a 'TreasuryFormSubmitted' track call.
 *
 * @param TreasuryFormSubmitted props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
function treasuryFormSubmitted(props, options, callback) {
    const a = analytics();
    if (a) {
        a.track('Treasury Form Submitted', props || {}, {
            ...options,
            context: {
                ...(options?.context || {}),
                typewriter: {
                    language: 'typescript',
                    version: '',
                },
            },
        }, callback);
    }
}
/**
 * Fires a 'VatCalculatorActioned' track call.
 *
 * @param VatCalculatorActioned props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
function vatCalculatorActioned(props, options, callback) {
    const a = analytics();
    if (a) {
        a.track('Vat Calculator Actioned', props || {}, {
            ...options,
            context: {
                ...(options?.context || {}),
                typewriter: {
                    language: 'typescript',
                    version: '',
                },
            },
        }, callback);
    }
}
/**
 * Fires a 'VideoPlayed' track call.
 *
 * @param VideoPlayed props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
function videoPlayed(props, options, callback) {
    const a = analytics();
    if (a) {
        a.track('Video Played', props || {}, {
            ...options,
            context: {
                ...(options?.context || {}),
                typewriter: {
                    language: 'typescript',
                    version: '',
                },
            },
        }, callback);
    }
}
/**
 * Fires a 'WebinarFormSubmitted' track call.
 *
 * @param WebinarFormSubmitted props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
function webinarFormSubmitted(props, options, callback) {
    const a = analytics();
    if (a) {
        a.track('Webinar Form Submitted', props || {}, {
            ...options,
            context: {
                ...(options?.context || {}),
                typewriter: {
                    language: 'typescript',
                    version: '',
                },
            },
        }, callback);
    }
}
/**
 * Fires a 'WebinarVideoViewed' track call.
 *
 * @param WebinarVideoViewed props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
function webinarVideoViewed(props, options, callback) {
    const a = analytics();
    if (a) {
        a.track('Webinar Video Viewed', props || {}, {
            ...options,
            context: {
                ...(options?.context || {}),
                typewriter: {
                    language: 'typescript',
                    version: '',
                },
            },
        }, callback);
    }
}
/**
 * Fires a 'WebinarsWatchNowctaActioned' track call.
 *
 * @param WebinarsWatchNowctaActioned props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
function webinarsWatchNowctaActioned(props, options, callback) {
    const a = analytics();
    if (a) {
        a.track('Webinars Watch Now CTA Actioned', props || {}, {
            ...options,
            context: {
                ...(options?.context || {}),
                typewriter: {
                    language: 'typescript',
                    version: '',
                },
            },
        }, callback);
    }
}
const clientAPI = {
    /**
     * Updates the run-time configuration of this Typewriter client.
     *
     * @param {TypewriterOptions} options - the options to upsert
     *
     * @typedef {Object} TypewriterOptions
     * @property {AnyAnalytics} [analytics] - Underlying analytics instance where analytics
     * 		calls are forwarded on to. Defaults to window.analytics.
     * @property {Function} [onViolation] - Handler fired when if an event does not match its spec. This handler does not fire in
     * 		production mode, because it requires inlining the full JSON Schema spec for each event in your Tracking Plan. By default,
     * 		it will throw errors if NODE_ENV="test" so that tests will fail if a message does not match the spec. Otherwise, errors
     * 		will be logged to stderr.
     */
    setTypewriterOptions,
    /**
     * Fires a 'BigformActioned' track call.
     *
     * @param BigformActioned props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    bigformActioned,
    /**
     * Fires a 'BigformSubmitted' track call.
     *
     * @param BigformSubmitted props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    bigformSubmitted,
    /**
     * Fires a 'BigformViewed' track call.
     *
     * @param BigformViewed props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    bigformViewed,
    /**
     * Fires a 'ContactUsPageContactFormActioned' track call.
     *
     * @param ContactUsPageContactFormActioned props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    contactUsPageContactFormActioned,
    /**
     * Fires a 'ContactUsPageEmailLinkActioned' track call.
     *
     * @param ContactUsPageEmailLinkActioned props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    contactUsPageEmailLinkActioned,
    /**
     * Fires a 'ContactUsPageHeroLinkActioned' track call.
     *
     * @param ContactUsPageHeroLinkActioned props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    contactUsPageHeroLinkActioned,
    /**
     * Fires a 'ContactUsPageIntercomLinkActioned' track call.
     *
     * @param ContactUsPageIntercomLinkActioned props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    contactUsPageIntercomLinkActioned,
    /**
     * Fires a 'CookieBannerActioned' track call.
     *
     * @param CookieBannerActioned props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    cookieBannerActioned,
    /**
     * Fires a 'CookiePreferencesActioned' track call.
     *
     * @param CookiePreferencesActioned props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    cookiePreferencesActioned,
    /**
     * Fires a 'CtaClicked' track call.
     *
     * @param CtaClicked props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    ctaClicked,
    /**
     * Fires a 'DemoBookingSubmitted' track call.
     *
     * @param DemoBookingSubmitted props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    demoBookingSubmitted,
    /**
     * Fires a 'DemoBookingViewed' track call.
     *
     * @param DemoBookingViewed props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    demoBookingViewed,
    /**
     * Fires a 'EpbActioned' track call.
     *
     * @param EpbActioned props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    epbActioned,
    /**
     * Fires a 'ErgActioned' track call.
     *
     * @param ErgActioned props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    ergActioned,
    /**
     * Fires a 'ElementClicked' track call.
     *
     * @param ElementClicked props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    elementClicked,
    /**
     * Fires a 'EmailSignupActioned' track call.
     *
     * @param EmailSignupActioned props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    emailSignupActioned,
    /**
     * Fires a 'EventCtaActioned' track call.
     *
     * @param EventCtaActioned props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    eventCtaActioned,
    /**
     * Fires a 'EventsRegisterctaActioned' track call.
     *
     * @param EventsRegisterctaActioned props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    eventsRegisterctaActioned,
    /**
     * Fires a 'FlowCompleted' track call.
     *
     * @param FlowCompleted props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    flowCompleted,
    /**
     * Fires a 'FlowStarted' track call.
     *
     * @param FlowStarted props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    flowStarted,
    /**
     * Fires a 'FlowStepCompleted' track call.
     *
     * @param FlowStepCompleted props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    flowStepCompleted,
    /**
     * Fires a 'FlowStepViewed' track call.
     *
     * @param FlowStepViewed props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    flowStepViewed,
    /**
     * Fires a 'FormSubmitted' track call.
     *
     * @param FormSubmitted props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    formSubmitted,
    /**
     * Fires a 'GoogleAdsOptimisationSignal' track call.
     *
     * @param GoogleAdsOptimisationSignal props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    googleAdsOptimisationSignal,
    /**
     * Fires a 'HomepageActioned' track call.
     *
     * @param HomepageActioned props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    homepageActioned,
    /**
     * Fires a 'HomepageStickyNavActioned' track call.
     *
     * @param HomepageStickyNavActioned props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    homepageStickyNavActioned,
    /**
     * Fires a 'InteractiveDemoActioned' track call.
     *
     * @param InteractiveDemoActioned props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    interactiveDemoActioned,
    /**
     * Fires a 'InteractiveDemoMobileGateContinueToDemoActioned' track call.
     *
     * @param InteractiveDemoMobileGateContinueToDemoActioned props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    interactiveDemoMobileGateContinueToDemoActioned,
    /**
     * Fires a 'InteractiveDemoMobileGateReturnHomepageActioned' track call.
     *
     * @param InteractiveDemoMobileGateReturnHomepageActioned props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    interactiveDemoMobileGateReturnHomepageActioned,
    /**
     * Fires a 'InvoiceGeneratorActioned' track call.
     *
     * @param InvoiceGeneratorActioned props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    invoiceGeneratorActioned,
    /**
     * Fires a 'InvoiceSubscribeActioned' track call.
     *
     * @param InvoiceSubscribeActioned props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    invoiceSubscribeActioned,
    /**
     * Fires a 'NavatticEvent' track call.
     *
     * @param NavatticEvent props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    navatticEvent,
    /**
     * Fires a 'NewsletterSignupFormSubmitted' track call.
     *
     * @param NewsletterSignupFormSubmitted props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    newsletterSignupFormSubmitted,
    /**
     * Fires a 'NotificationBannerActioned' track call.
     *
     * @param NotificationBannerActioned props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    notificationBannerActioned,
    /**
     * Fires a 'PageActioned' track call.
     *
     * @param PageActioned props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    pageActioned,
    /**
     * Fires a 'PageTranslated' track call.
     *
     * @param PageTranslated props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    pageTranslated,
    /**
     * Fires a 'PageViewed' track call.
     *
     * @param PageViewed props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    pageViewed,
    /**
     * Fires a 'PartnerCtaActioned' track call.
     *
     * @param PartnerCtaActioned props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    partnerCtaActioned,
    /**
     * Fires a 'PerformanceMarketingSignupActioned' track call.
     *
     * @param PerformanceMarketingSignupActioned props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    performanceMarketingSignupActioned,
    /**
     * Fires a 'PlanSelected' track call.
     *
     * @param PlanSelected props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    planSelected,
    /**
     * Fires a 'PricingBillingCycleActioned' track call.
     *
     * @param PricingBillingCycleActioned props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    pricingBillingCycleActioned,
    /**
     * Fires a 'PricingPlanPickerActioned' track call.
     *
     * @param PricingPlanPickerActioned props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    pricingPlanPickerActioned,
    /**
     * Fires a 'PricingSliderActioned' track call.
     *
     * @param PricingSliderActioned props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    pricingSliderActioned,
    /**
     * Fires a 'PricingTooltipActioned' track call.
     *
     * @param PricingTooltipActioned props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    pricingTooltipActioned,
    /**
     * Fires a 'RoicActioned' track call.
     *
     * @param RoicActioned props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    roicActioned,
    /**
     * Fires a 'ResourceRequested' track call.
     *
     * @param ResourceRequested props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    resourceRequested,
    /**
     * Fires a 'SignupFormModalOpened' track call.
     *
     * @param SignupFormModalOpened props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    signupFormModalOpened,
    /**
     * Fires a 'SignupFormSubmitted' track call.
     *
     * @param SignupFormSubmitted props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    signupFormSubmitted,
    /**
     * Fires a 'SignupFunnelSignalEvent' track call.
     *
     * @param SignupFunnelSignalEvent props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    signupFunnelSignalEvent,
    /**
     * Fires a 'SliceUseCaseActioned' track call.
     *
     * @param SliceUseCaseActioned props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    sliceUseCaseActioned,
    /**
     * Fires a 'SliderCardsButtonActioned' track call.
     *
     * @param SliderCardsButtonActioned props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    sliderCardsButtonActioned,
    /**
     * Fires a 'TopNavigationSignupActioned' track call.
     *
     * @param TopNavigationSignupActioned props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    topNavigationSignupActioned,
    /**
     * Fires a 'TreasuryFormSubmitted' track call.
     *
     * @param TreasuryFormSubmitted props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    treasuryFormSubmitted,
    /**
     * Fires a 'VatCalculatorActioned' track call.
     *
     * @param VatCalculatorActioned props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    vatCalculatorActioned,
    /**
     * Fires a 'VideoPlayed' track call.
     *
     * @param VideoPlayed props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    videoPlayed,
    /**
     * Fires a 'WebinarFormSubmitted' track call.
     *
     * @param WebinarFormSubmitted props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    webinarFormSubmitted,
    /**
     * Fires a 'WebinarVideoViewed' track call.
     *
     * @param WebinarVideoViewed props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    webinarVideoViewed,
    /**
     * Fires a 'WebinarsWatchNowctaActioned' track call.
     *
     * @param WebinarsWatchNowctaActioned props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    webinarsWatchNowctaActioned,
};
exports.default = new Proxy(clientAPI, {
    get(target, method) {
        if (typeof method === 'string' && target.hasOwnProperty(method)) {
            return target[method];
        }
        return () => {
            console.warn(`⚠️  You made an analytics call (${String(method)}) that can't be found. Either:
         a) Re-generate your typewriter client: \`npx typewriter\`
         b) Add it to your Tracking Plan: https://app.segment.com/segment-oscb/protocols/tracking-plans/rs_1zTHJU9fd5mt7cndWnd4PgJbMCE`);
            const a = analytics();
            if (a) {
                a.track('Unknown Analytics Call Fired', {
                    method,
                }, withTypewriterContext());
            }
        };
    },
});
